import styled from "styled-components";
import { colors, typeface } from "../theme";

export const InputField = styled.div`
  display: inline-flex;
  flex-direction: column;
  background: ${colors.white};
  font-family: ${typeface.primary};
  padding: 0;
  margin-bottom: 1rem;

  > label {
    &:first-child {
      margin-bottom: 0.3rem;
    }

    &:last-child {
      margin-top: 0.3rem;
    }
  }
`;
